<template>
  <div>
    <install-app />
  </div>
</template>

<script>
import InstallApp from '@/components/Services/Hosting/Shared/Installer/InstallApp'

export default {
  name: 'AppInstaller',
  components: {
    InstallApp
  }
}
</script>
